/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import CreateForm from '../CreateForm/CreateForm';
import FormWrapper from './FormWrapper';
import useFormikTemplate from '../hooks/useFormikTemplate';

interface I_GenericForm {
  fields: any;
  submitAction: (values: any) => void;
  formId?: string;
  navigation?: boolean;
  submitLabel?: string;
  className?: string;
}

function GenericForm({
  fields,
  submitAction,
  formId,
  navigation = false,
  submitLabel,
  className = '',
}: I_GenericForm) {
  // Initial values
  const [formik] = useFormikTemplate({
    initial: fields,
    yupValues: fields,
    submitAction,
  });

  return (
    // @ts-ignore
    <FormWrapper
      id={formId}
      handleSubmit={formik.handleSubmit}
      isSubmitting={navigation}
      dirty={formik.dirty}
      isValid={formik.isValid}
      label={submitLabel}
      className={className}
    >
      {/* @ts-ignore */}
      <CreateForm structure={fields} {...formik} />
    </FormWrapper>
  );
}

export default GenericForm;
